const User = (props) => {
  const _width = props.width || 24;
  return (
    <svg
      id="icon-user"
      xmlns="http://www.w3.org/2000/svg"
      data-name="icon-user"
      viewBox="0 0 58 57"
      width={_width}
      fill="none"
      {...props}
    >
      <path
        d="M28.9998 28.5C35.6733 28.5 41.0832 23.1834 41.0832 16.625C41.0832 10.0666 35.6733 4.75 28.9998 4.75C22.3264 4.75 16.9165 10.0666 16.9165 16.625C16.9165 23.1834 22.3264 28.5 28.9998 28.5Z"
        stroke="#292D32"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.24072 52.25C8.24072 43.0588 17.5449 35.625 28.9999 35.625C31.3199 35.625 33.5674 35.9337 35.6699 36.5037"
        stroke="#292D32"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M53.1668 42.75C53.1668 44.5312 52.6594 46.2175 51.7652 47.6425C51.2577 48.4975 50.6052 49.2575 49.856 49.875C48.1643 51.3712 45.941 52.25 43.5002 52.25C39.9718 52.25 36.9026 50.3975 35.2351 47.6425C34.341 46.2175 33.8335 44.5312 33.8335 42.75C33.8335 39.7575 35.2352 37.0738 37.4585 35.34C39.126 34.0338 41.2285 33.25 43.5002 33.25C48.841 33.25 53.1668 37.5012 53.1668 42.75Z"
        stroke="#292D32"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M39.73 42.7498L42.1225 45.101L47.27 40.4224"
        stroke="#292D32"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default User;
